// Language Switcher for the hamburger nav
import React, { useContext, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import GlobeIcon from './assets/images/icons/globe-icon.svg';
import i18nContext from '@components/i18n/i18nContext';
import { LANGUAGES } from '@helpers';
import styles from './LanguageSwitch.module.scss';
import i18n from '@components/i18n/i18n';

export const LanguageSwitch = ({ className, isReservePage }) => {
  const { lng } = useContext(i18nContext);
  const direction = i18n.dir();
  const windowExists = typeof window !== 'undefined';
  const selectRef = useRef();
  let isSafari = false;

  const handleChange = event => {
    const { value } = event.target;
    if (selectRef.current) {
      selectRef.current.classList.add(styles.hide);
    }
    if (value !== lng) {
      if (typeof window !== `undefined`) {
        const path = window.location.pathname.replace(
          LANGUAGES[lng].prefix,
          ''
        ); // remove old prefix from path
        window.location.href =
          window.location.origin + LANGUAGES[value].prefix + path; // add selected prefix to path
      }
    }
  };

  useEffect(() => {
    if (windowExists) {
      isSafari = window.safari !== undefined;
    }
  });

  return (
    <main className={styles.main}>
      <img
        className={`${
          isSafari && direction === 'rtl'
            ? styles.safariOnly
            : direction === 'rtl'
            ? null
            : styles.enGlobeIcon
        }
        ${isReservePage ? styles.isReserve : null} ${styles.globeIcon}`}
        src={GlobeIcon}
        alt="Globe Icon"
      />
      <select
        ref={selectRef}
        className={`${styles.select} ${className} ${
          direction !== 'rtl' ? styles.ltrSelect : styles.rtlSelect
        }`}
        defaultValue={lng}
        onChange={e => handleChange(e)}
      >
        {Object.keys(LANGUAGES).map(langcode =>
          LANGUAGES[langcode].languageSwitcher ? (
            <option key={langcode} value={langcode}>
              {LANGUAGES[langcode].label}
            </option>
          ) : null
        )}
        ;
      </select>
    </main>
  );
};

LanguageSwitch.propTypes = {
  className: PropTypes.string,
};

LanguageSwitch.defaultProps = {
  className: null,
};
